/*
  Lisen – kurvskuffen: kampagne-nudges og packshots (Claude, sep. 2026)

  Kurvskuffen tegnes af theme.js ud fra /cart.js og kender derfor hverken
  kollektioner, metafelter eller packshots. Begge dele hentes i stedet fra
  serveren i ÉT kald med Shopifys Section Rendering:
  sections/lisen-kurv-kampagne.liquid. Kaldet bærer kurv-cookien med, så
  Liquid ser præcis den kurv, kunden har.

  Kurvsiden er serverbygget og klarer begge dele selv – den behøver ikke dette.

  HVOR NUDGEN SKAL IND
  Skuffen er bygget sådan:
    #CartContainer
      form.ajaxcart
        div.drawer__inner            position: absolute  (den der scroller)
          div.drawer__products-wrapper
            div.ajaxcart__product × n
        div.drawer__footer           position: absolute  (fastlåst nederst)

  Hver blok fra serveren har data-linje med varens nummer i kurven og sættes
  ind lige efter netop den vare. Varen får samtidig klassen har-kampagne, så
  assets/lisen-kurv.css kan fjerne dens skillestreg og lade kampagnelinjen
  overtage rollen som deling mellem varerne.

  Først blev blokkene sat i #CartContainer. Begge børn derinde er absolut
  placeret, så de havnede i normalt flow øverst og lagde sig oven i varen.
  Derfor placeres de nu inde i varelisten.

  PACKSHOTS
  Samme svar indeholder en lille JSON-liste over de varer, der har et
  packshot. Billedet byttes ud bagefter. Temaet bruger lazysizes, så både
  src, srcset og data-src skal sættes – ellers overskriver lazysizes vores
  billede igen, næste gang den kigger på elementet. Varer uden packshot står
  ikke på listen og beholder deres eget billede.

  Skuffen tegnes om ved hver ændring, så alt dette forsvinder igen hver gang.
  Derfor holdes øje med #CartContainer, og der hentes på ny, når indholdet
  har ændret sig. Kaldene samles op i ét, så en hurtig række ændringer kun
  giver ét kald.
*/
(function () {
  'use strict';

  var MAAL = 'CartContainer';
  var SEKTION = 'lisen-kurv-kampagne';
  var KLASSE = 'lisen-kurvkamp-liste';
  var MARKE = 'har-kampagne';
  var VARE = '.ajaxcart__product';
  var BILLEDMARKE = 'lisen-packshot';
  var ventetid = null;
  var henter = false;

  function beholder() { return document.getElementById(MAAL); }

  function rod() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function liste(boks) {
    return boks.querySelector('.drawer__products-wrapper') ||
           boks.querySelector('.drawer__inner') ||
           boks;
  }

  function harVarer(boks) {
    return !!boks.querySelector(VARE + ', [data-line], input[name="updates[]"]');
  }

  function ryd(boks) {
    var gamle = boks.querySelectorAll('.' + KLASSE);
    for (var i = 0; i < gamle.length; i++) {
      if (gamle[i].parentNode) gamle[i].parentNode.removeChild(gamle[i]);
    }
    var markerede = boks.querySelectorAll(VARE + '.' + MARKE);
    for (var j = 0; j < markerede.length; j++) markerede[j].classList.remove(MARKE);
  }

  // Fritlagt billede i stedet for modelbillede, på de varer der har et
  function saetBilleder(boks, hylster) {
    var data = hylster.querySelector('script.lisen-kurv-billeder');
    if (!data) return;
    var liste;
    try { liste = JSON.parse(data.textContent) || []; } catch (e) { return; }
    var varer = boks.querySelectorAll(VARE);
    for (var i = 0; i < liste.length; i++) {
      var post = liste[i];
      var vare = varer[post.l - 1];
      if (!vare) continue;
      var img = vare.querySelector('img');
      if (!img || img.getAttribute('data-' + BILLEDMARKE) === post.u) continue;
      // lazysizes læser data-src og srcset – begge skal med, ellers kommer
      // modelbilledet tilbage ved næste gennemgang
      img.setAttribute('data-' + BILLEDMARKE, post.u);
      img.setAttribute('data-src', post.u);
      img.removeAttribute('data-widths');
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.src = post.u;
    }
  }

  function saetInd(boks, html) {
    ryd(boks);
    if (!html) return;

    var hylster = document.createElement('div');
    hylster.innerHTML = html;

    var ark = hylster.querySelector('link[rel="stylesheet"]');
    if (ark && !document.querySelector('link[href="' + ark.getAttribute('href') + '"]')) {
      document.head.appendChild(ark);
    }

    var varer = boks.querySelectorAll(VARE);
    var blokke = hylster.querySelectorAll('.' + KLASSE);

    for (var i = 0; i < blokke.length; i++) {
      var blok = blokke[i];
      var nr = parseInt(blok.getAttribute('data-linje'), 10);
      var vare = (nr && varer[nr - 1]) ? varer[nr - 1] : null;
      if (vare && vare.parentNode) {
        vare.parentNode.insertBefore(blok, vare.nextSibling);
        vare.classList.add(MARKE);
      } else {
        liste(boks).appendChild(blok);
      }
    }

    saetBilleder(boks, hylster);
  }

  function hent() {
    var boks = beholder();
    if (!boks || henter) return;
    if (!harVarer(boks)) { ryd(boks); return; }
    henter = true;
    fetch(rod() + '?section_id=' + SEKTION, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        henter = false;
        var b = beholder();
        if (b) saetInd(b, html);
      })
      .catch(function () { henter = false; });
  }

  function planlaeg() {
    if (ventetid) clearTimeout(ventetid);
    ventetid = setTimeout(hent, 180);
  }

  function start() {
    var boks = beholder();
    if (!boks) return;

    new MutationObserver(function (ting) {
      for (var i = 0; i < ting.length; i++) {
        var m = ting[i];
        var egen = false;
        var tjek = function (l) {
          for (var j = 0; j < l.length; j++) {
            var n = l[j];
            if (n.nodeType === 1 && n.classList && n.classList.contains(KLASSE)) egen = true;
          }
        };
        tjek(m.addedNodes);
        tjek(m.removedNodes);
        if (!egen) { planlaeg(); return; }
      }
    }).observe(boks, { childList: true, subtree: true, attributes: false });

    if (window.jQuery) {
      window.jQuery('body').on('added.ajaxProduct ajaxCart.afterCartLoad', planlaeg);
    }

    planlaeg();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
